import { FileBasic } from '@commenda/types/src/file/types';
import { fetcher } from '@commenda/utils';
import { MarketplaceServiceStatus } from '@prisma/client';

export async function updateMarketplaceService({
  caFirmId,
  companyId,
  marketplaceServiceRequestId,
  status,
  corporationId,
  statusUpdateComment,
  file,
}: {
  companyId: number;
  corporationId?: number;
  caFirmId?: string;
  marketplaceServiceRequestId: string;
  status?: MarketplaceServiceStatus;
  statusUpdateComment?: string;
  file?: FileBasic;
}) {
  const response = await fetcher(
    `marketplace/service-requests/${marketplaceServiceRequestId}`,
    {
      method: 'POST',
      body: {
        caFirmId,
        companyId,
        corporationId,
        ...(status ? { status } : {}),
        ...(statusUpdateComment ? { statusUpdateComment } : {}),
        ...(file ? { files: [file] } : {}),
      },
    },
    undefined
  );

  return response;
}
